
import { GetterTree } from 'vuex';
import { IPropertyEditState } from '../property-states.store';

const mijnVerhuisGetters: GetterTree<IPropertyEditState, {}> = <GetterTree<IPropertyEditState, {}>>{
  service: (state: IPropertyEditState) => state.service,
  mijnverhuis: (state: IPropertyEditState) => state.mijnverhuis,
  MijnverhuisPrimaryContact: (state: IPropertyEditState) => state.mijnverhuis.PrimaryContact,
  MijnverhuisSecondaryContact: (state: IPropertyEditState) => state.mijnverhuis.SecondaryContact,
  MijnverhuisLeavingCustomer: (state: IPropertyEditState) => state.mijnverhuis.LeavingCustomer,
  MijnverhuisConnection: (state: IPropertyEditState) => state.mijnverhuis.Connection,
}

export default mijnVerhuisGetters;